import { Page as PDFPage } from '@react-pdf/renderer';

import { styles } from './styles';

type PageProps = {
  children: React.ReactNode;
};

export function Page({ children }: PageProps) {
  return (
    <PDFPage size="A4" style={styles.page}>
      {children}
    </PDFPage>
  );
}
